<template>
  <v-footer padless light class="d-none d-sm-flex">
    <v-container>
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row align="center" justify="space-between">
            <v-col cols="3">
              <router-link :to="{ name: 'home' }">
                <WedNicelyLogo :style="{ height: 'auto', width: 100 + '%' }" />
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link
                :to="{ name: 'privacyPolicy' }"
                class="text--primary text-decoration-none"
              >
                <span>{{ $t("PRIVACY_POLICY") }}</span>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link
                :to="{ name: 'faq' }"
                class="text--primary text-decoration-none"
              >
                <span>{{ $t("FAQ") }}</span>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <a href="/blog" class="text--primary text-decoration-none">
                <span>{{ $t("BLOGS") }}</span>
              </a>
            </v-col>
            <v-col cols="auto">
              <router-link
                :to="{ name: 'contactUs' }"
                class="text--primary text-decoration-none"
              >
                <span>{{ $t("CONTACT_US") }}</span>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <a
                v-for="(social, i) in social_media"
                :key="i"
                :href="social.link"
                rel="noopener"
                target="_blank"
                class="mr-3"
              >
                <img
                  :alt="social.title"
                  :src="social.img_url"
                  height="24"
                  width="24"
                />
              </a>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="auto">
              <a href="https://codenicely.in">
                <img
                  alt="CodeNicely Software Services LLP"
                  height="54"
                  src="@/assets/logo/cn-logo.png"
                />
              </a>
            </v-col>
            <v-col cols="auto">
              <v-row no-gutters>
                <v-col class="font-weight-bold"
                  >CodeNicely Software Services LLP</v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col class="text--secondary">
                  CodeNicely Office, Office 306, 36Inc, Pandri, Raipur,
                  Chhattisgarh
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import WedNicelyLogo from "@/assets/logo/wednicely_logo.svg?inline";

export default {
  components: {
    WedNicelyLogo
  },

  data() {
    return {
      invitation: [
        { title: "Invitation", url: "" },
        { title: "Greeting", url: "" }
      ],
      category: [
        { title: "Category", url: "" },
        { title: "Wedding Card", url: "" },
        { title: "Engagement Card", url: "" },
        { title: "Save the Date", url: "" },
        { title: "Birthday Card", url: "" },
        { title: "Haldi Card", url: "" },
        { title: "Mehndi Card", url: "" },
        { title: "Customized Card", url: "" }
      ],
      footer_content: [
        { title: "Blog", href: "/blog" },
        { title: "About", to: { name: "aboutUs" } },
        { title: "Privacy Policy", to: { name: "privacyPolicy" } },
        { title: "FAQ", to: { name: "faq" } },
        { title: "Contact", to: { name: "contactUs" } }
      ],
      social_media: [
        {
          title: "Facebook",
          img_url: require("@/assets/social-media/facebook.png"),
          link: "https://www.facebook.com/wednicely"
        },
        {
          title: "Instagram",
          img_url: require("@/assets/social-media/instagram.png"),
          link: "https://www.instagram.com/wednicely/"
        },
        {
          title: "LinkedIn",
          img_url: require("@/assets/social-media/linkedin.png"),
          link: "https://www.linkedin.com/company/wednicely/"
        }
      ]
    };
  }
};
</script>
